var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faTriangleExclamation as fadTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons/faTriangleExclamation';
import { faCoffee as falCoffee } from '@fortawesome/pro-light-svg-icons/faCoffee';
import { faHandHoldingBox } from '@fortawesome/pro-light-svg-icons/faHandHoldingBox';
import { faPaperclip } from '@fortawesome/pro-light-svg-icons/faPaperclip';
import { faStopwatch } from '@fortawesome/pro-light-svg-icons/faStopwatch';
import { faArrowRightToBracket } from '@fortawesome/pro-regular-svg-icons/faArrowRightToBracket';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { faBox as faBoxRegular } from '@fortawesome/pro-regular-svg-icons/faBox';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCalendarPlus } from '@fortawesome/pro-regular-svg-icons/faCalendarPlus';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronRight as farChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { faCircleArrowDown } from '@fortawesome/pro-regular-svg-icons/faCircleArrowDown';
import { faCircleArrowRight } from '@fortawesome/pro-regular-svg-icons/faCircleArrowRight';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons/faCircleQuestion';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faCoffee as farCoffee } from '@fortawesome/pro-regular-svg-icons/faCoffee';
import { faCommentDots } from '@fortawesome/pro-regular-svg-icons/faCommentDots';
import { faComments } from '@fortawesome/pro-regular-svg-icons/faComments';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons/faEllipsisVertical';
import { faEnvelope as faEnvelopeLight } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faEyeSlash } from '@fortawesome/pro-regular-svg-icons/faEyeSlash';
import { faFaceMeh } from '@fortawesome/pro-regular-svg-icons/faFaceMeh';
import { faFile } from '@fortawesome/pro-regular-svg-icons/faFile';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { faFileLines } from '@fortawesome/pro-regular-svg-icons/faFileLines';
import { faFileSearch } from '@fortawesome/pro-regular-svg-icons/faFileSearch';
import { faFilter } from '@fortawesome/pro-regular-svg-icons/faFilter';
import { faGear } from '@fortawesome/pro-regular-svg-icons/faGear';
import { faHand } from '@fortawesome/pro-regular-svg-icons/faHand';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons/faPenToSquare';
import { faShareSquare } from '@fortawesome/pro-regular-svg-icons/faShareSquare';
import { faSquareMinus } from '@fortawesome/pro-regular-svg-icons/faSquareMinus';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons/faTrashCan';
import { faTriangleExclamation as farTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAnglesRight } from '@fortawesome/pro-solid-svg-icons/faAnglesRight';
import { faArrowDownToBracket } from '@fortawesome/pro-solid-svg-icons/faArrowDownToBracket';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons/faBadgeCheck';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faBox } from '@fortawesome/pro-solid-svg-icons/faBox';
import { faBoxArchive } from '@fortawesome/pro-solid-svg-icons/faBoxArchive';
import { faBoxCircleCheck } from '@fortawesome/pro-solid-svg-icons/faBoxCircleCheck';
import { faBoxOpen } from '@fortawesome/pro-solid-svg-icons/faBoxOpen';
import { faBoxesStacked } from '@fortawesome/pro-solid-svg-icons/faBoxesStacked';
import { faUpDownLeftRight } from '@fortawesome/pro-solid-svg-icons/faUpDownLeftRight';
import { faCamera } from '@fortawesome/pro-solid-svg-icons/faCamera';
import { faCartArrowDown } from '@fortawesome/pro-solid-svg-icons/faCartArrowDown';
import { faChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faChevronDown as fasChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronUp as fasChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faCoffee as fasCoffee } from '@fortawesome/pro-solid-svg-icons/faCoffee';
import { faComputerMouseScrollwheel } from '@fortawesome/pro-solid-svg-icons/faComputerMouseScrollwheel';
import { faCrop } from '@fortawesome/pro-solid-svg-icons/faCrop';
import { faCube } from '@fortawesome/pro-solid-svg-icons/faCube';
import { faEquals } from '@fortawesome/pro-solid-svg-icons/faEquals';
import { faFluxCapacitor } from '@fortawesome/pro-solid-svg-icons/faFluxCapacitor';
import { faWineGlassCrack } from '@fortawesome/pro-solid-svg-icons/faWineGlassCrack';
import { faBatteryBolt } from '@fortawesome/pro-solid-svg-icons/faBatteryBolt';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faFlaskRoundPotion } from '@fortawesome/pro-solid-svg-icons/faFlaskRoundPotion';
import { faExchange } from '@fortawesome/pro-solid-svg-icons/faExchange';
import { faFlag } from '@fortawesome/pro-solid-svg-icons/faFlag';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGreaterThanEqual } from '@fortawesome/pro-solid-svg-icons/faGreaterThanEqual';
import { faHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faHouseUser } from '@fortawesome/pro-solid-svg-icons/faHouseUser';
import { faLaptopCode } from '@fortawesome/pro-solid-svg-icons/faLaptopCode';
import { faLessThanEqual } from '@fortawesome/pro-solid-svg-icons/faLessThanEqual';
import { faLocationCrosshairs } from '@fortawesome/pro-solid-svg-icons/faLocationCrosshairs';
import { faLuggageCart } from '@fortawesome/pro-solid-svg-icons/faLuggageCart';
import { faMinus } from '@fortawesome/pro-solid-svg-icons/faMinus';
import { faNotEqual } from '@fortawesome/pro-solid-svg-icons/faNotEqual';
import { faNoteSticky } from '@fortawesome/pro-solid-svg-icons/faNoteSticky';
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faPeopleCarry as fasPeopleCarry } from '@fortawesome/pro-solid-svg-icons/faPeopleCarry';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faShelves } from '@fortawesome/pro-solid-svg-icons/faShelves';
import { faShippingFast } from '@fortawesome/pro-solid-svg-icons/faShippingFast';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import { faStore } from '@fortawesome/pro-solid-svg-icons/faStore';
import { faTags } from '@fortawesome/pro-solid-svg-icons/faTags';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faTruck } from '@fortawesome/pro-solid-svg-icons/faTruck';
import { faTruckRampBox } from '@fortawesome/pro-solid-svg-icons/faTruckRampBox';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUsersGear } from '@fortawesome/pro-solid-svg-icons/faUsersGear';
import { faWatch } from '@fortawesome/pro-solid-svg-icons/faWatch';
import { faWebhook } from '@fortawesome/pro-solid-svg-icons/faWebhook';
import { faXmark as fasXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { useTheme } from '@xstyled/styled-components';
import { th } from '@xstyled/styled-components';
export var iconDictionary = {
    greaterThan: faAngleRight,
    startsWith: faAnglesRight,
    lessThen: faAngleLeft,
    endsWith: faBan,
    pen: faPen,
    edit: faPenToSquare,
    avatar: faUser,
    arrowLeft: faArrowLeft,
    arrowsRotate: faArrowsRotate,
    upDownLeftRight: faUpDownLeftRight,
    attachment: faPaperclip,
    dashboard: faChartLine,
    chevronUp: faChevronUp,
    chevronDown: faChevronDown,
    chevronRight: farChevronRight,
    clock: faClock,
    complaint: faFileAlt,
    computerMouseScrollwheel: faComputerMouseScrollwheel,
    mailLight: faEnvelopeLight,
    eshop: faStore,
    expedition: faShippingFast,
    equals: faEquals,
    fluxCapacitor: faFluxCapacitor,
    wineGlassCrack: faWineGlassCrack,
    paperPlane: faPaperPlane,
    flaskRoundPotion: faFlaskRoundPotion,
    batteryBolt: faBatteryBolt,
    ellipsisVertical: faEllipsisVertical,
    greaterThanEqual: faGreaterThanEqual,
    home: faHome,
    gear: faGear,
    inbound: faCartArrowDown,
    inventory: faFile,
    knowledgeBase: faLaptopCode,
    luggageCart: faLuggageCart,
    lessThanEqual: faLessThanEqual,
    logout: faArrowRightToBracket,
    login: faArrowRightToBracket,
    logs: faCopy,
    notification: faBell,
    organisation: faHouseUser,
    partner: farTriangleExclamation,
    exchangeRates: farTriangleExclamation,
    product: faBoxOpen,
    box: faBox,
    boxRegular: faBoxRegular,
    boxes: faBoxesStacked,
    boxChecked: faBoxCircleCheck,
    shelves: faShelves,
    reservation: faHandHoldingBox,
    return: [faShareSquare, 'horizontal'],
    search: faSearch,
    supplier: farTriangleExclamation,
    transfer: faExchange,
    users: faUsersGear,
    warning: farTriangleExclamation,
    close: fasXmark,
    false: fasXmark,
    deleteX: fasXmark,
    deleteCan: faTrashCan,
    import: faCircleArrowDown,
    export: faCircleArrowRight,
    check: faCheck,
    camera: faCamera,
    crop: faCrop,
    squareCheck: faSquareCheck,
    squareMinus: faSquareMinus,
    goLeft: faChevronLeft,
    goRight: fasChevronRight,
    goDown: fasChevronDown,
    goUp: fasChevronUp,
    internal: faEyeSlash,
    password: faLock,
    notEqual: faNotEqual,
    calendar: faCalendar,
    note: faNoteSticky,
    comments: faComments,
    commentDots: faCommentDots,
    calendarPlus: faCalendarPlus,
    download: faArrowDownToBracket,
    plus: faPlus,
    minus: faMinus,
    warningDual: fadTriangleExclamation,
    info: faCircleInfo,
    cube: faCube,
    flatBox: faBoxArchive,
    link: faLink,
    facebook: faFacebookF,
    twitter: faTwitter,
    youtube: faYoutube,
    linkedin: faLinkedinIn,
    instagram: faInstagram,
    faceMeh: faFaceMeh,
    handStop: faHand,
    drag: faHand,
    flag: faFlag,
    findDetail: faFileSearch,
    compass: faLocationCrosshairs,
    boxRamp: faTruckRampBox,
    earth: faGlobe,
    filePlaceholder: faFileLines,
    tags: faTags,
    circleCheck: faCircleCheck,
    circleX: faCircleXmark,
    circleTriangle: faTriangleExclamation,
    questionMak: faCircleQuestion,
    badgeCheck: faBadgeCheck,
    peopleCarry: fasPeopleCarry,
    stopwatch: faStopwatch,
    truck: faTruck,
    webhook: faWebhook,
    watch: faWatch,
    filter: faFilter
};
library.add(farCoffee, fasCoffee, falCoffee, faHandHoldingBox, faLuggageCart, faPaperclip, fasPeopleCarry, faStopwatch, faTruck, faWatch, faFileSearch, faCircleCheck, faCircleXmark, faTriangleExclamation, faBadgeCheck);
var iconPrefixMap = {
    normal: 'far',
    light: 'fal',
    solid: 'fas'
};
var FaIconSizing = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  --fa-secondary-color: ", ";\n  --fa-secondary-opacity: 1;\n  display: ", ";\n"], ["\n  ", "\n  --fa-secondary-color: ", ";\n  --fa-secondary-opacity: 1;\n  display: ", ";\n"])), function (_a) {
    var size = _a.size;
    return size && "font-size: ".concat(size, ";");
}, function (_a) {
    var $colorSecondary = _a.$colorSecondary;
    return $colorSecondary;
}, function (_a) {
    var $fixedWidth = _a.$fixedWidth;
    return ($fixedWidth ? 'contents' : 'block');
});
var Icon = function (_a) {
    var icon = _a.icon, fill = _a.fill, _b = _a.style, style = _b === void 0 ? 'normal' : _b, size = _a.size, className = _a.className, secondaryColor = _a.secondaryColor, _c = _a.fixedWidth, fixedWidth = _c === void 0 ? true : _c, spinning = _a.spinning;
    var theme = useTheme();
    var colorFill = fill && th.color(fill)({ theme: theme }); // React.Text wont return number here
    var colorSecondary = secondaryColor && th.color(secondaryColor)({ theme: theme });
    var namedIcon = (typeof icon == 'string' && (iconDictionary === null || iconDictionary === void 0 ? void 0 : iconDictionary[icon])) || false;
    var iconProp = React.useMemo(function () {
        if (namedIcon) {
            return Array.isArray(namedIcon) ? namedIcon[0] : namedIcon;
        }
        return [iconPrefixMap[style], icon];
    }, [icon, style, namedIcon]);
    var flipProp = (namedIcon && Array.isArray(namedIcon) && namedIcon[1]) || undefined;
    return (_jsx(FaIconSizing, { size: size, className: className !== null && className !== void 0 ? className : '', "$colorSecondary": colorSecondary, "$fixedWidth": fixedWidth, children: _jsx(FontAwesomeIcon, { color: colorFill, flip: flipProp, icon: iconProp, className: "faIcon ".concat(fixedWidth ? 'fa-fw' : '', " ").concat(spinning ? 'fa-spin' : '') }) }));
};
export default Icon;
var templateObject_1;
